export const CREATE_LEGACY_CONTACT_URL = '/_api/contacts-legacy-app/v3/contacts'
export const SUBMIT_CONTACT_URL = '/_api/contacts/v4/contact-submit'
export const EMAIL_CONTACT_URL = '/_api/shoutout/v1/emailContact'
export const EMAIL_MEMBER_URL = '/_api/shoutout/v1/emailMember'

export const AppDefIds = {
	shoutOut: '135c3d92-0fea-1f9d-2ba5-2a1dfb04297e',
	wixCode: '675bbcef-18d8-41f5-800e-131ec9e08762',
}
